import dash_api from '../../../../main/support/dash_api';
import { ReduxAsyncAction } from '../../../services/ReduxAsyncAction';
import type { CustomPartnerLimitResponse } from '../../../../../../shared/types/customPartnerLimits.types';
import type { Action } from 'redux';

const GetCustomPartnersLimit = new ReduxAsyncAction<'GET_CUSTOM_PARTNERS_LIMIT', void, CustomPartnerLimitResponse>(
  'GET_CUSTOM_PARTNERS_LIMIT'
);

GetCustomPartnersLimit.registerRequest(async () => {
  const response = await dash_api.get<CustomPartnerLimitResponse>('/v1/ad-network/custom-partners-limit');
  return response.data;
});

export const GET_CUSTOM_PARTNERS_LIMIT = GetCustomPartnersLimit.actionNamespaceConstants;

export const getCustomPartnersLimit = GetCustomPartnersLimit.request;

export type GetCustomPartnersLimitRequestAction = Action<typeof GET_CUSTOM_PARTNERS_LIMIT.request>;

export type GetCustomPartnersLimitResponseAction = Action<typeof GET_CUSTOM_PARTNERS_LIMIT.response> & {
  data: CustomPartnerLimitResponse;
};

export type GetCustomPartnersLimitErrorAction = Action<typeof GET_CUSTOM_PARTNERS_LIMIT.error> & {
  data: Record<string, any>;
};
